import { render, staticRenderFns } from "./purchaseOrderList.vue?vue&type=template&id=47df2b68&"
import script from "./purchaseOrderList.vue?vue&type=script&lang=js&"
export * from "./purchaseOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports